module.exports = __webpack_public_path__ + "static/img/66.729171be.jpg";